import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          {/*<CFView h3 futura bold color="#D42027" mb="20px">
            SOCIAL MEDIA
          </CFView>*/}
          <CFView row center white bold>
            {/*<CFLink href="https://www.facebook.com/pages/Japan-Sushi/132671153423528">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Ebisu Sushi Bar Facebook"
              />
            </CFLink>*/}
            {/* <CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Ebisu Sushi Bar Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          {/*<CFView h3 futura bold color="#D42027" mb="15px">
            SOCIAL MEDIA
          </CFView>*/}
          <CFView row justifyStart alignCenter white bold>
            {/*<CFLink href="https://www.facebook.com/pages/Japan-Sushi/132671153423528">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Ebisu Sushi Bar Facebook"
                hover
              />
            </CFLink>*/}
            {/* <CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Ebisu Sushi Bar Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
